import AxiosInstance from "./API/AxiosInstance";

export const login = async (email, password) => {
  const response = await AxiosInstance.post(`/api/auth/login`,{email, password});
  return response.data;
};


export const Logout = async (id) => {
  const response = await AxiosInstance.get(`/api/auth/logout`);
  return response.data;
};

export const ForgotPassword = async (email) => {
  const response = await AxiosInstance.post(`/api/auth/forgotpassword`,{email});
  return response.data;
};


export const verifyOtp = async (email, otp) => {
  const response = await AxiosInstance.post(`/api/auth/verify-otp`, { email, otp });
   return response.data;
};

export const resetPassword = async (email, otp, newPassword) => {
 const response = await AxiosInstance.put(`/api/auth/reset-password`, { email, otp, newPassword });
  return response.data;
};